import { Log, apiRequest ,Paginacion } from '@ext/utils';
export * from './AtributosGenerales.types'
import { IAtributosGenerales } from './AtributosGenerales.lib';

export class AtributosGenerales extends IAtributosGenerales {

    public static async create( id: string ): Promise<AtributosGenerales>
    {
        let o = new AtributosGenerales();
        o.Articulo = id;
        if ( await o.find() ) {
            return o;
        }
        return null;
    }

    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `/articulos/${this.Articulo.eliminar('/')}/atributos/generales`;
        if ( await request.get() ) {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public async save(): Promise<boolean> {

        try {
            let js = this.getJson();
            let req = new apiRequest();
            req.body = js;
            if ( this.Existe ) {
                req.path = `/articulos/${this.Articulo.eliminar( '/' )}/atributos/generales`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    this.set();
                }
            }
            return true;
        } catch ( e ) {
            Log( e );
        }
        return false;
    }
}